<template>
  <component :is="clienteData === undefined ? 'div' : 'b-card'">

    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="clienteData === undefined"
    >
      <h4 class="alert-heading">
        Error fetching user data
      </h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'apps-list'}"
        >
          User List
        </b-link>
        for other users.
      </div>
    </b-alert>

    <form-add-cliente
      :cliente-data="clienteData"
      class="pt-75"
      @handleSubmit="handleSubmit"
    />

  </component>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink,
} from 'bootstrap-vue'
import { ref, onMounted } from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import FormAddCliente from './FormAddCliente.vue'

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,

    FormAddCliente,
  },
  setup() {
    const clienteData = ref({
      id_cliente: null,
      nome_cliente: '',
      tipo_pessoa_cliente: 'F',
      documento_cliente: '',
      ativo_cliente: 1,
      login_usuario: '',
      senha_usuario: '',
      endereco_cliente_endereco: '',
      numero_cliente_endereco: '',
      complemento_cliente_endereco: '',
      cep_cliente_endereco: '',
      bairro_cliente_endereco: '',
      cidade_cliente_endereco: '',
      inscricao_estadual_cliente_endereco: '',
      pais_id_cliente_endereco: 1,
      uf_id_cliente_endereco: null,
      id_grupousuario: null,
    })

    const resetClienteData = () => {
      clienteData.value = {
        id_cliente: null,
        nome_cliente: '',
        tipo_pessoa_cliente: 'F',
        documento_cliente: '',
        ativo_cliente: 1,
        login_usuario: '',
        senha_usuario: '',
        endereco_cliente_endereco: '',
        numero_cliente_endereco: '',
        complemento_cliente_endereco: '',
        cep_cliente_endereco: '',
        bairro_cliente_endereco: '',
        cidade_cliente_endereco: '',
        inscricao_estadual_cliente_endereco: '',
        pais_id_cliente_endereco: 1,
        uf_id_cliente_endereco: null,
        id_grupousuario: null,
      }
    }


    const handleSubmit = () => {
      if (clienteData.value.id_cliente !== null) {
        store.dispatch('appAdmCliente/updateCliente', clienteData.value)
          .then(() => {
            router.push({ name: 'app-admin-cliente' })
          })
        return
      }
      store.dispatch('appAdmCliente/saveCliente', clienteData.value)
        .then(() => {
          router.push({ name: 'app-admin-cliente' })
        })
    }

    return {
      clienteData,
      handleSubmit,
      resetClienteData,
    }
  },
}
</script>

<style>

</style>
